import { SVGProps } from '@repo/toolkit/types'
import React from 'react'

interface LogoProps extends SVGProps {
  text?: string
  displayGradient?: boolean
}

const Logo: React.FC<LogoProps> = ({ text, displayGradient = false, ...props }) => {
  return (
    <svg
      width="200"
      height="140"
      viewBox="0 0 200 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_207_9215)">
        <path d="M48.315 110.512V84.8876H24.333L24.159 2.89258H0V110.512H48.315Z" fill="white" />
        <path
          d="M82.7283 40.9606H109.815V65.1216H82.9012V84.8876H112.74V110.512H54.9062V2.89258H112.74V28.5166H82.9012L82.7283 40.9606Z"
          fill="white"
        />
        <path
          d="M198.601 7.68C190.399 2.799 180.817 0 170.585 0C140.274 0 115.711 24.566 115.711 54.876C115.711 85.179 140.274 109.749 170.585 109.749C181.407 109.749 191.498 106.612 200.001 101.201L186.267 78.02C181.792 81.053 176.395 82.829 170.585 82.829C155.146 82.829 142.624 70.311 142.624 54.876C142.624 39.433 155.145 26.921 170.585 26.921C174.439 26.921 179.685 27.832 183.029 29.248L198.601 7.68Z"
          fill="white"
        />
      </g>

      {text && (
        <>
          {displayGradient && (
            <>
              <rect x="5" y="125" width="42" height="4" fill="url(#paint0_linear_209_9305)" />

              <rect x="155" y="125" width="42" height="4" fill="url(#paint1_linear_209_9305)" />
            </>
          )}

          <text
            x="99.5"
            y="134"
            fill="white"
            fontSize="21"
            fontFamily="sans-serif"
            textAnchor="middle"
            fontWeight="500"
            className="select-none"
          >
            {text}
          </text>
        </>
      )}

      <defs>
        <linearGradient
          id="paint0_linear_209_9305"
          x1="9"
          y1="125.5"
          x2="51"
          y2="125.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2E8EA0" stopOpacity="0.08" />
          <stop offset="1" stopColor="#F9F9F9" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_209_9305"
          x1="148"
          y1="125.5"
          x2="190"
          y2="125.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9F9F9" />
          <stop offset="1" stopColor="#2E8EA0" stopOpacity="0.08" />
        </linearGradient>
        <clipPath id="clip0_207_9215">
          <rect width="200" height="110" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Logo
